export const IssueFormMetadataRels = {
    GetIssueFormFieldTypes: 'getIssueFormFieldTypes',
    SetIssueFormFieldType: 'setIssueFormFieldType'
};
